import { get, post } from "../axiosConfig";
import { User } from "../../../types";
import { LoginResponse, SigninResponse } from "../../../features/auth/types";

export const AuthAPI = {
  async signinUser(formData: {
    username: string;
    email: string;
    password: string;
  }): Promise<SigninResponse> {
    const { data } = await post("/signup", formData);
    return data.result;
  },

  async getSessionId(formData: {
    username: string;
    password: string;
  }): Promise<LoginResponse> {
    const { data } = await post("/token", formData);
    return data;
  },

  async getUserBySessionId(): Promise<User> {
    const { data } = await get("/me");
    return data;
  },

  async confirmEmail(token: string): Promise<string> {
    const { data } = await post("/confirm-email", { token });
    return data;
  },

  async sendConfirmationEmail(email: string): Promise<string> {
    const { data } = await post("/send-confirmation-email", { email });
    return data;
  },

  async sendResetPasswordEmail(email: string): Promise<string> {
    const { data } = await post("/send-reset-password-email", { email });
    return data;
  },

  async resetPassword({
    password,
    token,
  }: {
    password: string;
    token: string;
  }): Promise<string> {
    const { data } = await post("/reset-password", { password, token });
    return data;
  },

  async changePassword({
    current_password,
    new_password,
  }: {
    current_password: string;
    new_password: string;
  }): Promise<string> {
    const { data } = await post("/change-password", {
      current_password,
      new_password,
    });
    return data;
  },
};
